import { render, staticRenderFns } from "./CreateBusiness.vue?vue&type=template&id=ee39db84&"
import script from "./CreateBusiness.vue?vue&type=script&lang=ts&"
export * from "./CreateBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBusiness.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports